import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import BooksCheckInput, { InputType } from '../../model1/forms/BooksCheckInput';
import BooksOutlineLabel from '../labels/BooksOutlineLabel';
import BooksTimeItem from '../texts/BooksTimeItem';

import css from './BooksSelectTimeEvent.module.scss';

interface Props {
  className?: string;
  postable: boolean;
  startTime: string;
  endTime: string;
  vacancy: number;
  showVacancy: boolean;
  attendees: number;
  value: string | number;
  checked: boolean;
  waitingListProvided: boolean;
  setNotification?: boolean;
  onChange?: (e: React.ChangeEvent) => void;
  onClickSetNotification?: (e: React.MouseEvent) => void;
}

const BooksSelectTimeEvent = ({
  className,
  postable,
  startTime,
  endTime,
  vacancy,
  showVacancy,
  value,
  checked,
  attendees,
  waitingListProvided,
  setNotification,
  onChange,
  onClickSetNotification,
  intl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksSelectTimeEvent, className);
  const timeClasses = classNames(
    css.BooksSelectTimeEvent__Time,
    vacancy < attendees || vacancy < 1 ? css.isDisabled : '',
  );
  const notificationClasses = classNames(
    css.BooksSelectTimeEvent__Notification,
    css.isSetNotification,
  );
  const labelClasses = classNames(
    css.BooksSelectTimeEvent__Label,
    { [css.isSoldOut]: !vacancy },
    className,
  );

  return (
    <div className={classes}>
      <BooksCheckInput
        type={InputType.Checkbox}
        name="event-select-time"
        checked={checked}
        onChange={onChange}
        disabled={vacancy < attendees || vacancy < 1}
        labelClassName={css.BooksSelectTimeEvent__Input}
        value={value}
      >
        <BooksTimeItem
          startTime={startTime}
          endTime={endTime}
          className={timeClasses}
        />
        <div className={css.BooksSelectTimeEvent__Labels}>
          {vacancy > attendees ? (
            showVacancy && (
              <BooksOutlineLabel
                label={`${intl.formatMessage({
                  id: 'merchants.services.status.vacancy',
                })} ${vacancy}`}
                className={css.BooksSelectTimeEvent__Label}
              />
            )
          ) : vacancy < 1 ? (
            <BooksOutlineLabel
              label={intl.formatMessage({
                id: 'merchants.services.status.soldOut',
              })}
              className={labelClasses}
            />
          ) : (
            showVacancy && (
              <BooksOutlineLabel
                label={`${intl.formatMessage({
                  id: 'merchants.services.status.vacancy',
                })} ${vacancy}`}
                className={css.BooksSelectTimeEvent__Label}
              />
            )
          )}
          {setNotification
            ? vacancy < 1 &&
              waitingListProvided && (
                <span className={notificationClasses}>
                  {intl.formatMessage({
                    id: 'books.notification.notificationSet',
                  })}
                </span>
              )
            : vacancy < 1 &&
              waitingListProvided && (
                <button
                  type="button"
                  value={value}
                  disabled={!postable}
                  className={css.BooksSelectTimeEvent__Notification}
                  onClick={onClickSetNotification}
                >
                  {intl.formatMessage({ id: 'books.notification.getNotified' })}
                  {!postable && (
                    <span className={css.BooksSelectTimeEvent__Loading} />
                  )}
                </button>
              )}
        </div>
      </BooksCheckInput>
    </div>
  );
};

export default injectIntl(BooksSelectTimeEvent);
